//client/src/config/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyA_7qlkhXmX89su64yeHBJi6llu5ZO25ec",
  authDomain: "dark-ripple-450705-q7.firebaseapp.com",
  projectId: "dark-ripple-450705-q7",
  storageBucket: "dark-ripple-450705-q7.firebasestorage.app",
  messagingSenderId: "936675328193",
  appId: "1:936675328193:web:e0a11561bbf66b2ca51440"
};

const app = initializeApp(firebaseConfig);

// gives us an auth instance
const auth = getAuth(app);

// in order to use this auth instance elsewhere
export default auth;